<template>
  <v-card outlined>
    <v-list-item>
      <v-list-item-icon v-if="icon">
        <v-icon :color="colour">
          {{ icon }}
        </v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ title }}</v-list-item-title>
        <v-list-item-subtitle>{{ subtitle }}</v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <template v-if="$listeners.select">
          <v-btn icon @click.stop="$emit('select', $event)">
            <v-icon color="primary">
              launch
            </v-icon>
          </v-btn>
        </template>
        <slot name="action" />
      </v-list-item-action>
    </v-list-item>
  </v-card>
</template>
<script>
export default {
  props: {
    icon: { type: String, default: '' },
    colour: { type: String, default: null },
    title: { type: String, required: true },
    subtitle: { type: String, required: true }
  }
}
</script>
